// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"64b50d0a","156":"735b054d","284":"65053c0b","398":"15c86f0c","410":"2d87a7bb","431":"474fba37","453":"3ae3c489","493":"b871aedc","705":"81d9dbe7","719":"e1cf54c4","729":"3dffa85e","852":"521904ca","969":"d63b59a1"}[chunkId] + ".chunk.js";
};